import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from 'utils/constant';

const MinimalLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn, token } = useSelector((s) => s.auth || {});

    useEffect(() => {
        if (isLoggedIn && token) {
            navigate(ROUTES.DASHBOARD, { replace: true });
        }
    }, [isLoggedIn, token, navigate, location.pathname]);

    return <Outlet />;
};

export default MinimalLayout;